<template>
  <div>
    <div class="outer-wrapper">
      <div class="container-fluid">
          <div class="row justify-content-center mob-row">
            <div class="col-sm-12 col-lg-8">
              <div class="col-sm-12  unit-plan-tab-section d-flex">
              <div class="col-lg-6 logo-header">
                <div class="brand-logo-mob text-left">
                  <img src="@/assets/images/mp-logo.png" width="100px" height="100px" alt="" class="img-fluid">
                </div>
              </div>              
              </div>
              <div class="plan-holder">
                <div class="mx-auto text-center floor-map-section w-100">
                  <svg id="floor_map" width="946" height="607" viewBox="0 0 946 607" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                    <path d="M660.33 16.18C659.53 16.18 658.79 16.035 658.11 15.745C657.44 15.455 656.85 15.05 656.34 14.53C655.84 14.01 655.45 13.4 655.17 12.7C654.89 12 654.75 11.235 654.75 10.405C654.75 9.575 654.885 8.81 655.155 8.11C655.435 7.4 655.825 6.79 656.325 6.28C656.835 5.76 657.43 5.36 658.11 5.08C658.79 4.79 659.53 4.645 660.33 4.645C661.13 4.645 661.845 4.78 662.475 5.05C663.115 5.32 663.655 5.68 664.095 6.13C664.535 6.57 664.85 7.055 665.04 7.585L663.21 8.44C663 7.88 662.645 7.42 662.145 7.06C661.645 6.69 661.04 6.505 660.33 6.505C659.63 6.505 659.01 6.67 658.47 7C657.94 7.33 657.525 7.785 657.225 8.365C656.935 8.945 656.79 9.625 656.79 10.405C656.79 11.185 656.935 11.87 657.225 12.46C657.525 13.04 657.94 13.495 658.47 13.825C659.01 14.155 659.63 14.32 660.33 14.32C661.04 14.32 661.645 14.14 662.145 13.78C662.645 13.41 663 12.945 663.21 12.385L665.04 13.24C664.85 13.77 664.535 14.26 664.095 14.71C663.655 15.15 663.115 15.505 662.475 15.775C661.845 16.045 661.13 16.18 660.33 16.18ZM669.441 16.18C668.811 16.18 668.261 16.04 667.791 15.76C667.331 15.48 666.976 15.09 666.726 14.59C666.486 14.09 666.366 13.505 666.366 12.835V7.84H668.331V12.67C668.331 13.01 668.396 13.31 668.526 13.57C668.666 13.82 668.861 14.02 669.111 14.17C669.371 14.31 669.661 14.38 669.981 14.38C670.301 14.38 670.586 14.31 670.836 14.17C671.086 14.02 671.281 13.815 671.421 13.555C671.561 13.295 671.631 12.985 671.631 12.625V7.84H673.596V16H671.736V14.395L671.901 14.68C671.711 15.18 671.396 15.555 670.956 15.805C670.526 16.055 670.021 16.18 669.441 16.18ZM678.528 16.18C677.658 16.18 676.898 15.975 676.248 15.565C675.608 15.145 675.168 14.58 674.928 13.87L676.398 13.165C676.608 13.625 676.898 13.985 677.268 14.245C677.648 14.505 678.068 14.635 678.528 14.635C678.888 14.635 679.173 14.555 679.383 14.395C679.593 14.235 679.698 14.025 679.698 13.765C679.698 13.605 679.653 13.475 679.563 13.375C679.483 13.265 679.368 13.175 679.218 13.105C679.078 13.025 678.923 12.96 678.753 12.91L677.418 12.535C676.728 12.335 676.203 12.03 675.843 11.62C675.493 11.21 675.318 10.725 675.318 10.165C675.318 9.665 675.443 9.23 675.693 8.86C675.953 8.48 676.308 8.185 676.758 7.975C677.218 7.765 677.743 7.66 678.333 7.66C679.103 7.66 679.783 7.845 680.373 8.215C680.963 8.585 681.383 9.105 681.633 9.775L680.133 10.48C679.993 10.11 679.758 9.815 679.428 9.595C679.098 9.375 678.728 9.265 678.318 9.265C677.988 9.265 677.728 9.34 677.538 9.49C677.348 9.64 677.253 9.835 677.253 10.075C677.253 10.225 677.293 10.355 677.373 10.465C677.453 10.575 677.563 10.665 677.703 10.735C677.853 10.805 678.023 10.87 678.213 10.93L679.518 11.32C680.188 11.52 680.703 11.82 681.063 12.22C681.433 12.62 681.618 13.11 681.618 13.69C681.618 14.18 681.488 14.615 681.228 14.995C680.968 15.365 680.608 15.655 680.148 15.865C679.688 16.075 679.148 16.18 678.528 16.18ZM686.848 16.09C685.928 16.09 685.213 15.84 684.703 15.34C684.203 14.83 683.953 14.115 683.953 13.195V9.595H682.543V7.84H682.693C683.093 7.84 683.403 7.735 683.623 7.525C683.843 7.315 683.953 7.01 683.953 6.61V5.98H685.918V7.84H687.793V9.595H685.918V13.09C685.918 13.36 685.963 13.59 686.053 13.78C686.153 13.97 686.303 14.115 686.503 14.215C686.713 14.315 686.978 14.365 687.298 14.365C687.368 14.365 687.448 14.36 687.538 14.35C687.638 14.34 687.733 14.33 687.823 14.32V16C687.683 16.02 687.523 16.04 687.343 16.06C687.163 16.08 686.998 16.09 686.848 16.09ZM693.241 16.18C692.441 16.18 691.711 15.995 691.051 15.625C690.401 15.255 689.881 14.75 689.491 14.11C689.111 13.47 688.921 12.74 688.921 11.92C688.921 11.1 689.111 10.37 689.491 9.73C689.881 9.09 690.401 8.585 691.051 8.215C691.701 7.845 692.431 7.66 693.241 7.66C694.041 7.66 694.766 7.845 695.416 8.215C696.066 8.585 696.581 9.09 696.961 9.73C697.351 10.36 697.546 11.09 697.546 11.92C697.546 12.74 697.351 13.47 696.961 14.11C696.571 14.75 696.051 15.255 695.401 15.625C694.751 15.995 694.031 16.18 693.241 16.18ZM693.241 14.38C693.681 14.38 694.066 14.275 694.396 14.065C694.736 13.855 695.001 13.565 695.191 13.195C695.391 12.815 695.491 12.39 695.491 11.92C695.491 11.44 695.391 11.02 695.191 10.66C695.001 10.29 694.736 10 694.396 9.79C694.066 9.57 693.681 9.46 693.241 9.46C692.791 9.46 692.396 9.57 692.056 9.79C691.716 10 691.446 10.29 691.246 10.66C691.056 11.02 690.961 11.44 690.961 11.92C690.961 12.39 691.056 12.815 691.246 13.195C691.446 13.565 691.716 13.855 692.056 14.065C692.396 14.275 692.791 14.38 693.241 14.38ZM699.036 16V7.84H700.881V9.73L700.671 9.415C700.821 8.825 701.121 8.385 701.571 8.095C702.021 7.805 702.551 7.66 703.161 7.66C703.831 7.66 704.421 7.835 704.931 8.185C705.441 8.535 705.771 8.995 705.921 9.565L705.366 9.61C705.616 8.96 705.991 8.475 706.491 8.155C706.991 7.825 707.566 7.66 708.216 7.66C708.796 7.66 709.311 7.79 709.761 8.05C710.221 8.31 710.581 8.675 710.841 9.145C711.101 9.605 711.231 10.14 711.231 10.75V16H709.266V11.215C709.266 10.855 709.201 10.545 709.071 10.285C708.941 10.025 708.761 9.825 708.531 9.685C708.301 9.535 708.021 9.46 707.691 9.46C707.381 9.46 707.106 9.535 706.866 9.685C706.626 9.825 706.441 10.025 706.311 10.285C706.181 10.545 706.116 10.855 706.116 11.215V16H704.151V11.215C704.151 10.855 704.086 10.545 703.956 10.285C703.826 10.025 703.641 9.825 703.401 9.685C703.171 9.535 702.896 9.46 702.576 9.46C702.266 9.46 701.991 9.535 701.751 9.685C701.511 9.825 701.326 10.025 701.196 10.285C701.066 10.545 701.001 10.855 701.001 11.215V16H699.036ZM712.894 16V7.84H714.859V16H712.894ZM712.894 6.925V4.825H714.859V6.925H712.894ZM715.968 16V14.41L720.708 8.92L721.008 9.595H716.178V7.84H722.748V9.445L718.098 14.935L717.798 14.26H722.778V16H715.968ZM726.369 16.18C725.799 16.18 725.304 16.085 724.884 15.895C724.464 15.705 724.139 15.435 723.909 15.085C723.679 14.725 723.564 14.31 723.564 13.84C723.564 13.39 723.664 12.99 723.864 12.64C724.064 12.28 724.374 11.98 724.794 11.74C725.214 11.5 725.744 11.33 726.384 11.23L729.054 10.795V12.295L726.759 12.685C726.369 12.755 726.079 12.88 725.889 13.06C725.699 13.24 725.604 13.475 725.604 13.765C725.604 14.045 725.709 14.27 725.919 14.44C726.139 14.6 726.409 14.68 726.729 14.68C727.139 14.68 727.499 14.595 727.809 14.425C728.129 14.245 728.374 14 728.544 13.69C728.724 13.38 728.814 13.04 728.814 12.67V10.57C728.814 10.22 728.674 9.93 728.394 9.7C728.124 9.46 727.764 9.34 727.314 9.34C726.894 9.34 726.519 9.455 726.189 9.685C725.869 9.905 725.634 10.2 725.484 10.57L723.879 9.79C724.039 9.36 724.289 8.99 724.629 8.68C724.979 8.36 725.389 8.11 725.859 7.93C726.329 7.75 726.839 7.66 727.389 7.66C728.059 7.66 728.649 7.785 729.159 8.035C729.669 8.275 730.064 8.615 730.344 9.055C730.634 9.485 730.779 9.99 730.779 10.57V16H728.919V14.605L729.339 14.575C729.129 14.925 728.879 15.22 728.589 15.46C728.299 15.69 727.969 15.87 727.599 16C727.229 16.12 726.819 16.18 726.369 16.18ZM737.051 16.18C736.461 16.18 735.916 16.065 735.416 15.835C734.926 15.595 734.536 15.255 734.246 14.815L734.441 14.425V16H732.596V4.645H734.561V9.46L734.261 9.055C734.541 8.615 734.921 8.275 735.401 8.035C735.881 7.785 736.436 7.66 737.066 7.66C737.836 7.66 738.531 7.85 739.151 8.23C739.771 8.61 740.261 9.12 740.621 9.76C740.991 10.4 741.176 11.12 741.176 11.92C741.176 12.71 740.996 13.43 740.636 14.08C740.276 14.73 739.786 15.245 739.166 15.625C738.546 15.995 737.841 16.18 737.051 16.18ZM736.826 14.38C737.276 14.38 737.676 14.275 738.026 14.065C738.376 13.855 738.646 13.565 738.836 13.195C739.036 12.825 739.136 12.4 739.136 11.92C739.136 11.44 739.036 11.02 738.836 10.66C738.646 10.29 738.376 10 738.026 9.79C737.676 9.57 737.276 9.46 736.826 9.46C736.396 9.46 736.006 9.565 735.656 9.775C735.316 9.985 735.046 10.28 734.846 10.66C734.656 11.03 734.561 11.45 734.561 11.92C734.561 12.4 734.656 12.825 734.846 13.195C735.046 13.565 735.316 13.855 735.656 14.065C736.006 14.275 736.396 14.38 736.826 14.38ZM742.674 16V4.645H744.639V16H742.674ZM750.323 16.18C749.483 16.18 748.748 15.99 748.118 15.61C747.488 15.23 746.998 14.715 746.648 14.065C746.298 13.415 746.123 12.695 746.123 11.905C746.123 11.085 746.298 10.36 746.648 9.73C747.008 9.09 747.493 8.585 748.103 8.215C748.723 7.845 749.413 7.66 750.173 7.66C750.813 7.66 751.373 7.765 751.853 7.975C752.343 8.185 752.758 8.475 753.098 8.845C753.438 9.215 753.698 9.64 753.878 10.12C754.058 10.59 754.148 11.1 754.148 11.65C754.148 11.79 754.138 11.935 754.118 12.085C754.108 12.235 754.083 12.365 754.043 12.475H747.743V10.975H752.933L752.003 11.68C752.093 11.22 752.068 10.81 751.928 10.45C751.798 10.09 751.578 9.805 751.268 9.595C750.968 9.385 750.603 9.28 750.173 9.28C749.763 9.28 749.398 9.385 749.078 9.595C748.758 9.795 748.513 10.095 748.343 10.495C748.183 10.885 748.123 11.36 748.163 11.92C748.123 12.42 748.188 12.865 748.358 13.255C748.538 13.635 748.798 13.93 749.138 14.14C749.488 14.35 749.888 14.455 750.338 14.455C750.788 14.455 751.168 14.36 751.478 14.17C751.798 13.98 752.048 13.725 752.228 13.405L753.818 14.185C753.658 14.575 753.408 14.92 753.068 15.22C752.728 15.52 752.323 15.755 751.853 15.925C751.393 16.095 750.883 16.18 750.323 16.18ZM758.469 16V4.825H760.509V14.2H765.294V16H758.469ZM768.923 16.18C768.353 16.18 767.858 16.085 767.438 15.895C767.018 15.705 766.693 15.435 766.463 15.085C766.233 14.725 766.118 14.31 766.118 13.84C766.118 13.39 766.218 12.99 766.418 12.64C766.618 12.28 766.928 11.98 767.348 11.74C767.768 11.5 768.298 11.33 768.938 11.23L771.608 10.795V12.295L769.313 12.685C768.923 12.755 768.633 12.88 768.443 13.06C768.253 13.24 768.158 13.475 768.158 13.765C768.158 14.045 768.263 14.27 768.473 14.44C768.693 14.6 768.963 14.68 769.283 14.68C769.693 14.68 770.053 14.595 770.363 14.425C770.683 14.245 770.928 14 771.098 13.69C771.278 13.38 771.368 13.04 771.368 12.67V10.57C771.368 10.22 771.228 9.93 770.948 9.7C770.678 9.46 770.318 9.34 769.868 9.34C769.448 9.34 769.073 9.455 768.743 9.685C768.423 9.905 768.188 10.2 768.038 10.57L766.433 9.79C766.593 9.36 766.843 8.99 767.183 8.68C767.533 8.36 767.943 8.11 768.413 7.93C768.883 7.75 769.393 7.66 769.943 7.66C770.613 7.66 771.203 7.785 771.713 8.035C772.223 8.275 772.618 8.615 772.898 9.055C773.188 9.485 773.333 9.99 773.333 10.57V16H771.473V14.605L771.893 14.575C771.683 14.925 771.433 15.22 771.143 15.46C770.853 15.69 770.523 15.87 770.153 16C769.783 16.12 769.373 16.18 768.923 16.18ZM776.139 19.315C775.919 19.315 775.704 19.295 775.494 19.255C775.284 19.225 775.094 19.17 774.924 19.09V17.44C775.054 17.47 775.209 17.5 775.389 17.53C775.579 17.56 775.754 17.575 775.914 17.575C776.364 17.575 776.689 17.47 776.889 17.26C777.099 17.05 777.284 16.775 777.444 16.435L777.984 15.175L777.954 16.825L774.399 7.84H776.514L779.004 14.47H778.254L780.729 7.84H782.859L779.304 16.825C779.094 17.355 778.839 17.805 778.539 18.175C778.239 18.545 777.889 18.825 777.489 19.015C777.099 19.215 776.649 19.315 776.139 19.315ZM787.782 16.18C786.982 16.18 786.252 15.995 785.592 15.625C784.942 15.255 784.422 14.75 784.032 14.11C783.652 13.47 783.462 12.74 783.462 11.92C783.462 11.1 783.652 10.37 784.032 9.73C784.422 9.09 784.942 8.585 785.592 8.215C786.242 7.845 786.972 7.66 787.782 7.66C788.582 7.66 789.307 7.845 789.957 8.215C790.607 8.585 791.122 9.09 791.502 9.73C791.892 10.36 792.087 11.09 792.087 11.92C792.087 12.74 791.892 13.47 791.502 14.11C791.112 14.75 790.592 15.255 789.942 15.625C789.292 15.995 788.572 16.18 787.782 16.18ZM787.782 14.38C788.222 14.38 788.607 14.275 788.937 14.065C789.277 13.855 789.542 13.565 789.732 13.195C789.932 12.815 790.032 12.39 790.032 11.92C790.032 11.44 789.932 11.02 789.732 10.66C789.542 10.29 789.277 10 788.937 9.79C788.607 9.57 788.222 9.46 787.782 9.46C787.332 9.46 786.937 9.57 786.597 9.79C786.257 10 785.987 10.29 785.787 10.66C785.597 11.02 785.502 11.44 785.502 11.92C785.502 12.39 785.597 12.815 785.787 13.195C785.987 13.565 786.257 13.855 786.597 14.065C786.937 14.275 787.332 14.38 787.782 14.38ZM796.487 16.18C795.857 16.18 795.307 16.04 794.837 15.76C794.377 15.48 794.022 15.09 793.772 14.59C793.532 14.09 793.412 13.505 793.412 12.835V7.84H795.377V12.67C795.377 13.01 795.442 13.31 795.572 13.57C795.712 13.82 795.907 14.02 796.157 14.17C796.417 14.31 796.707 14.38 797.027 14.38C797.347 14.38 797.632 14.31 797.882 14.17C798.132 14.02 798.327 13.815 798.467 13.555C798.607 13.295 798.677 12.985 798.677 12.625V7.84H800.642V16H798.782V14.395L798.947 14.68C798.757 15.18 798.442 15.555 798.002 15.805C797.572 16.055 797.067 16.18 796.487 16.18ZM806.189 16.09C805.269 16.09 804.554 15.84 804.044 15.34C803.544 14.83 803.294 14.115 803.294 13.195V9.595H801.884V7.84H802.034C802.434 7.84 802.744 7.735 802.964 7.525C803.184 7.315 803.294 7.01 803.294 6.61V5.98H805.259V7.84H807.134V9.595H805.259V13.09C805.259 13.36 805.304 13.59 805.394 13.78C805.494 13.97 805.644 14.115 805.844 14.215C806.054 14.315 806.319 14.365 806.639 14.365C806.709 14.365 806.789 14.36 806.879 14.35C806.979 14.34 807.074 14.33 807.164 14.32V16C807.024 16.02 806.864 16.04 806.684 16.06C806.504 16.08 806.339 16.09 806.189 16.09Z" fill="black"/>
                    <rect y="171" width="473" height="284" rx="8" fill="url(#pattern0)"/>
                    <rect x="515" y="19" width="431" height="588" fill="url(#pattern1)"/>
                    <defs>
                    <pattern id="pattern0" patternContentUnits="objectBoundingBox" width="1" height="1">
                    <use xlink:href="#image0_473_391" transform="matrix(0.000608331 0 0 0.00101317 -0.0335064 0)"/>
                    </pattern>
                    <pattern id="pattern1" patternContentUnits="objectBoundingBox" width="1" height="1">
                    <use xlink:href="#image1_473_391" transform="matrix(0.000855432 0 0 0.000627026 0 -0.00162067)"/>
                    </pattern>
                    <image id="image0_473_391" width="1754" height="987" :href="`${selectedFloor.elevation}`" />
                    <image id="image1_473_391" width="1169" height="1600" :href="`${selectedFloor.floorPlan}`" />
                    </defs>
                  </svg>
                </div>
                <div class="unit-progress-bar">
                  <ProgressBar :steps="formSteps" :activeStepNo="2"/>
                </div>
              </div>
            </div>
            <div class="col-sm-12 col-lg-4 right-container">
              <UnitForm/>
            </div>
          </div>
           <div class="col-12 powered-by powered-by-mob">Powered by <span class="powered-by-ppistol"> PropertyPistol&nbsp;Technologies</span></div>
        <!-- <ArialView />
        <VirtualVisit /> -->

      </div>

    </div>
  </div>

</template>
<script>

import {FormSteps} from '@/assets/scripts/utility.js';


export default {
  components: {
    FloorPlanSVG:()=>import("@/components/FloorPlanSVG.vue"),
    UnitForm: ()=>import("@/components/Home/UnitForm.vue"),
    ProgressBar: ()=>import('@/components/ProgressBar.vue')
  },
  data(){
    return{
      formSteps:FormSteps
    }
  },
  mounted(){
    this.$store.dispatch('setLoading',false);
  },
  computed: {
    selectedFloor() {
      return this.$store.getters.selectedFloor;
    },
    selectedTypology() {
      return this.$store.getters.selectedTypology;
    }
  },
  methods: {
    // typologyPlanSrc() {
    //   return require(`@/assets/images/floorplan.jpg`);
    // },
    toggleTab(id,btnId){
      $('#planTabs .tab-pane').removeClass('active');
      $(`${id}`).addClass('active');
      $('.nav-pills .unit-button').removeClass('active');
      $(btnId).addClass('active');

    }
  }
};
</script>
<style scoped>
.logo-header {
  display: flex;
  position: absolute;
  z-index: 1000;
}

#floor_map{
  width: 100%;
  height: 100%;
}
.mob-show{
  display: none;
}
.outer-wrapper {
  margin: 0;
  background: #f6f6f6;

}

.right-container{
  background: #ffffff;
  padding: 0px 30px;
  position: relative;
  z-index: 2;
}

.title-section{
  display: flex;
}

.unit-plans-buttons{
  display: flex;
  margin-left: auto;
  align-items: flex-end;
}

.plan-holder {
  border-radius: 10px;
  padding: 0;
  background: transparent;
  padding-bottom: 20px;
}

.tab-content .tab-pane{
  overflow-x: auto;
}

.plan-holder-img{
  max-height: 516px;
}

.compass-img{
  margin-left: auto;
  margin-top: auto;
}

.compass-img-mob{
  display: none;
}

@media (min-width:992px){
  .plan-holder{
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
    height: 100vh;
  }
  .unit-progress-bar{
    position: absolute;
    bottom: 5px;
    width: 100%;
    left: 50%;
    transform: translateX(-50%);
  }
}

.plan-holder h3 {
  font-weight: 600;
  font-size: 18px;
  color: #082D57;
  border-bottom: 2px solid #F5F5F5;
  padding: 20px;
}


.side-menu {
  padding-top: 20px;
  padding-bottom: 20px;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.brand-logo {
  display: flex;
  align-items: center;
  gap: 20px;
  padding: 20px;
  margin-bottom: 20px;
}

h3 {
  font-weight: 600;
  font-size: 20px;
  color: #000000;
  padding: 20px;
  margin: revert;
}

.side-menu.typology {
  height: 100%;
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.12);
  border-radius: 10px 0px 0px 10px;
  position: relative;
}

.side-menu.typology .list-group {
  flex-direction: column;
}

.side-menu.typology .list-group-item {
  padding: 5px 0;
}

.custom-control {
  margin-right: 0;
}

.custom-control-label {
  padding: 15px 15px 15px 40px;
}

.custom-control-label .divider {
  width: 5px;
  height: 100%;
  border-radius: 0px 4px 4px 0px;
}

.typology .custom-control-label::before,
.typology .custom-control-label::after {
  top: 17px;
  left: 15px;
}

.custom-radio .custom-control-input:checked~.custom-control-label::after {
  top: 20px;
  left: 18px;
}

.side-action {
  display: flex;
  flex-direction: column;
  padding: 0 20px;
  gap: 15px;
  position: absolute;
  bottom: 0;
  width: 100%;
  z-index: 1;
  background: #fff;
  border-radius: 10px;
}

.prevButton {
  color: #082D57;
  border: none;
  background: transparent;
  font-weight: 600;
  font-size: 16px;
  margin-top: 15px;
  opacity: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
}

.side-action .btn-primary {
  background: #082D57;
  border-radius: 4px;
  padding: 15px;
}

.side-action p {
  font-weight: 400;
  font-size: 9px;
  color: #082D57;
  opacity: 0.5;
  text-align: center;
}
.form-wrapper {
  padding: 0 20px;
}
.form-wrapper  label {
  font-weight: 500;
  font-size: 12px;
  letter-spacing: -0.01em;
  color: #082D57;
  opacity: 0.5;
}
.form-wrapper  select {
  background: url(../assets/images/caret-icon.svg) no-repeat right .75rem center #FFFFFF;
  border: 1px solid #E7EBF0;
  border-radius: 3px;
  padding: 10px;
  appearance: none;
  height: auto;
  font-weight: 600;
  font-size: 15px;
  color: #082D57;
}
.sub-head {
  font-weight: 600;
  font-size: 15px;
  color: #082D57;
  display: block;
}
.card-foot {
    background: #FFFFFF;
    border: 1px solid #FFFFFF;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.2);
    border-radius: 10px;
    padding: 20px;
  }
  .card-footer-head span{
    letter-spacing: -0.01em;
    color: #082D57;
    opacity: 0.5;
    font-weight: 500;
    font-size: 12px;
  }
  h5 {
    font-weight: 600;
    font-size: 15px;
    color: #082D57;
  }
.link-btn {
  position: absolute;
  transform: translate(-50%,-50%);
  top: 50%;
  left: 50%;
}

.unit-button,
.nav-pills .nav-link{
  background: #AB3E9180;
  color: #ffffff80;
  padding: 8px;
}

.nav-pills .nav-item:first-child .nav-link{
  border-radius: 4px 0px 0px 4px;
}

.nav-pills .nav-item:last-child .nav-link{
  border-radius: 0px 4px 4px 0px;
}
.nav-pills .nav-link.active, .nav-pills .show > .nav-link{
  background: #AB3E91;
  color: #ffffff;
}

.powered-by-mob{
  display: none;
}

.powered-by{
  font-weight: 400;
  font-size: 11px;
  line-height: 13px;
  color: #00000080;
  text-align: center;
  margin-top: 20px;
}
.powered-by .powered-by-ppistol{
  color: #000000;
}

.info-wrapper{
    margin-bottom: 40px;
    background: #fff;
    padding-right: 15px;
    border-radius: 10px;
    display: flex;
 }

  .info-wrapper h2{
    font-size: 12px;
    font-weight: bold;
    color: #000;
    margin-bottom: 10px;
  }
     .info-wrapper .page-heading {
    font-size: 12px;
    font-weight: bold;
    color: #000;
    font-weight: 700;
    font-size: 24px;
    margin-bottom: 4px;
  }

  .info-wrapper p {
    font-size: 13px;
    color: #000000;
    line-height: 16px;
    text-transform: uppercase;
    opacity: 0.5;
    padding-left: 0px;
    padding-bottom: 0px;
    margin-bottom: 14px;
  }
.info-wrapper .align-data {
    font-size: 13px;
    color: #000000;
    line-height: 16px;
    text-transform: none;
    opacity: 0.5;
    padding-left: 0px;
    padding-top: 0;
    margin-bottom: 0;
 }
@media (min-width: 992px){
  .right-container{
    overflow-y: auto;
    height: 100vh;
  }
}

@media (max-width:991px){

  .unit-plan-tab-section{
    position: static;
    margin-top: 80px;
  }

  .mob-hide{
    display: none;
  }

  .row.mob-show{
    display: flex;
  }
  .info-wrapper.mob-show{
    padding:104px 20px 30px 5px;
    background: #FFFFFF;
    border: 1px solid rgba(73, 72, 153, 0.2);
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.03);
  }
  .right-container{
    margin-top: 20px;
    position: static;
    padding: 0;
  }
  .logo-header{
    position: absolute;
    top: 0;
    left: 0;
    background: #FFFFFF;
    box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.04);
  }

  .logo-header h3{
    margin: auto;
  }

  .brand-logo-mob{
    position: absolute;
  }

  .powered-by{
    display: none;
  }

  .powered-by.powered-by-mob{
    display: block;
    position: static;
    margin: auto;
    text-align: center;
    transform: none;
    margin-top: 40px;
    margin-bottom: 160px;
  }
  .side-menu{
    min-height: unset;
  }
  .unit-plans-buttons{
    justify-content: center;
  }
  .plan-holder-img{
    width: 100%;
  }
  .plan-holder .tab-content{
    margin-bottom: 20px !important;
  }
  .compass-img{
    display: none;
  }
  .compass-img-mob{
    display: block;
    position: absolute;
    top: 0;
    right: 0;
  }

}
</style>